import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CardLoaderSize } from "../data-visualization";
import { DashboardTabAbstractComponent } from "../dashboard-tab-abstract.component";
import { ReportDimensions } from "../../reports/models/reports";
import {
  returnsActivityStats,
  returnsAiInsights,
  returnsHints,
  returnsOffers,
  returnsOffersNameColumn,
  returnsOffersValueColumns,
  returnsOutcomesData,
  returnsOutcomesLegend,
  returnsProducts,
  returnsProductsNameColumn,
  returnsProductsValueColumns,
  returnsReasons,
  returnsReasonsNameColumn,
  returnsReasonsValueColumns,
  returnsTopCards,
  unlock360Subtitle,
} from "./returns.data";

@Component({
  selector: "app-returns-dashboard",
  templateUrl: "./returns.component.html",
  styleUrls: ["./../dashboard-section.scss", "./../dashboard-section-v2.scss", "./returns.component.scss"],
})
export class DashboardReturnsComponent extends DashboardTabAbstractComponent {
  @Output() reportNavigate = new EventEmitter<string>();
  @Input() cardsLoading: boolean = false;
  @Input() activityLoading: boolean = false;

  topCards = returnsTopCards;
  outcomesData = returnsOutcomesData;
  outcomesLegend = returnsOutcomesLegend;
  activityStats = returnsActivityStats;
  reasons = returnsReasons;
  reasonsNameColumn = returnsReasonsNameColumn;
  reasonsValueColumns = returnsReasonsValueColumns;
  products = returnsProducts;
  productsNameColumn = returnsProductsNameColumn;
  productsValueColumns = returnsProductsValueColumns;
  offers = returnsOffers;
  offersNameColumn = returnsOffersNameColumn;
  offersValueColumns = returnsOffersValueColumns;
  aiInsights = returnsAiInsights;
  hints = returnsHints;
  unlock360Subtitle = unlock360Subtitle;
  reportDimensions = ReportDimensions;
  cardLoaderSize = CardLoaderSize;

  navigateToReport(dimension: string) {
    this.reportNavigate.emit(dimension);
  }

  // Export icon only shows once a stat has a real, non-zero count.
  get hasActivityData(): boolean {
    return this.activityStats.some((stat) => stat.count !== '--' && stat.count !== '0');
  }
}
